module.exports = __webpack_public_path__ + "static/media/nav_logo.08527bb2.svg";